export default __webpack_public_path__ + "static/media/servicenow_logo.be174726.png";